import { render } from "./RemoveMenuCategory.vue?vue&type=template&id=e3baf544&scoped=true"
import script from "./RemoveMenuCategory.vue?vue&type=script&lang=js"
export * from "./RemoveMenuCategory.vue?vue&type=script&lang=js"

import "./RemoveMenuCategory.vue?vue&type=style&index=0&id=e3baf544&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3baf544"]])

export default __exports__